import React from 'react';

import Form from 'components/Members/LearningStyle/Widgets/LearningStyleForm/Index';

import { useContext } from 'components/Members/Onboarding/Context';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import { useContext as useUsersContext } from 'components/Users/Context';

import StepTab from 'components/new_ui/Tabs/StepTab';

export default function LearningStyle() {
  const { dispatch, state, actions } = useContext();
  const { state: stateUsers } = useUsersContext();

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: false,
        currentStep: state.currentStep,
      });
    });
  };

  if (stateUsers.user === null) {
    return (
      <div className="content onboarding-content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <>
      <div className="onboarding-content">
        <StepTab total={5} current={3} />
      </div>
      <div className="content onboarding-content">
        <section>
          <h1 className="mb-3">Learning Style</h1>

          <p>
            Part of matching with the right coach is understanding how you learn best.
            Don&apos;t think too deeply about each question. Your gut reaction is what we want to capture.
          </p>
        </section>

        <Form
          submitText="Next"
          afterSubmit={() => {
            onGoNextClick();
          }}
        />
      </div>
    </>
  );
}
